module.exports = __webpack_public_path__ + "media/images/flags/br-acf8bd843121f58e726851b3f4d9aa55.svg";